export default {
  statistics: {
    total_campaigns: 'Gesamtkampagnen',
    todays_sent_messages: 'Heute gesendete Nachrichten',
    total_subscribers: 'Abonnenten',
    average_click_rate: 'Durchschnittliche Klickrate',
  },
};
